import { Record } from '../transit'

const Attendance = Record({
  _id: '',
  company: '',
  companyName: '',
  location: '',
  locationName: '',
  date: '',
  courseType: '',
  pdf: '',
  feedbacksPdf: '',
  pdfAt: '',
  pdfFor: 0,
  archived: false,
  instructor: '',
  instructorName: '',
  note: '',
  sendDate: null,
  state: '',
  drivers: [],
  timetable: '',
  timetableDrivers: ''
}, 'attendance')

export default Attendance



// WEBPACK FOOTER //
// ./src/common/attendances/Attendance.js